import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES, type TokenId } from "@/types";
import { createEventEmitter } from "@/events";

export const REDEEM_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.REDEEM}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface RedeemSuccessPayload {
    transactionHash: TransactionHash;
    redeemTokenId: TokenId;
    redeemAmount: number;
}

export interface RedeemEventPayloads extends Record<string, unknown> {
    [REDEEM_EVENTS.SUCCESS]: RedeemSuccessPayload;
}

export const redeemEventEmitter = createEventEmitter<RedeemEventPayloads>();
